import { Component, OnInit } from '@angular/core';
import {ITableHeader} from "../../../../../interfaces/table-header";
import {TableHeaderService} from "../../../../../resources/services/table-header.service";

@Component({
  selector: 'ui-user-purchases',
  templateUrl: './ui-user-purchases.component.html'
})
export class UiUserPurchasesComponent implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.id({name: 'Purchase ID'}),
    this.tableHeaderService.price(),
    this.tableHeaderService.currency(),
    this.tableHeaderService.market(),
    this.tableHeaderService.type(),
    this.tableHeaderService.createdAt(),
    this.tableHeaderService.expiredAt(),
    this.tableHeaderService.productType(),
    this.tableHeaderService.receipt({sort: false}),
    this.tableHeaderService.force(),
    this.tableHeaderService.subject({filter: false}),
  ];

  data: any = {
    id: '09876543210098765',
    price: 15,
    currency: '$',
    market: 'IOS',
    type: 'Subscription',
    createdAt: new Date(),
    expiredAt: new Date(),
    productType: 'Consumable',
    receipt: '123456789',
    force: true,
    subject: 'subject'
  };

  source: any[] = new Array(6).fill(this.data);

  constructor(private tableHeaderService: TableHeaderService) { }

  ngOnInit(): void {
  }

}
